var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MsisdnService } from '../../shared/msisdn/msisdn.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { createUniqueLabelValidator } from '../../shared/msisdn/number-label.validator';
import { blankStringValidator } from '../../shared/validators/blank-string.validator';
import { fourByteStringValidator } from '../../shared/validators/four-byte-string.validator';
import { NotificationService } from '../../shared/notification.service';
var LabelErrorStateMatcher = /** @class */ (function () {
    function LabelErrorStateMatcher() {
    }
    LabelErrorStateMatcher.prototype.isErrorState = function (control, form) {
        var isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    };
    return LabelErrorStateMatcher;
}());
export { LabelErrorStateMatcher };
var LabelUpdaterComponent = /** @class */ (function () {
    function LabelUpdaterComponent(locationStrategy, msisdnService, translateService, notificationService) {
        this.locationStrategy = locationStrategy;
        this.msisdnService = msisdnService;
        this.translateService = translateService;
        this.notificationService = notificationService;
        this.labelChange = new EventEmitter();
        this.matcher = new LabelErrorStateMatcher();
        this.savingMutex = false;
    }
    LabelUpdaterComponent.prototype.ngOnInit = function () {
        this.form = new FormGroup({
            label: new FormControl(this.msisdn.label, {
                validators: [Validators.required, blankStringValidator, Validators.maxLength(100), fourByteStringValidator],
                asyncValidators: createUniqueLabelValidator(this.msisdnService, this.msisdn.label.trim()),
                updateOn: 'change'
            })
        });
    };
    LabelUpdaterComponent.prototype.visibleNumber = function () {
        return this.msisdn && this.msisdn.msisdn ? this.msisdn.msisdn : this.translateService.instant('PENDING') + '...';
    };
    LabelUpdaterComponent.prototype.disableButton = function () {
        return (this.savingMutex ||
            this.form.hasError('unique', ['label']) ||
            this.form.hasError('required', ['label']) ||
            this.form.hasError('blank', ['label']) ||
            this.form.hasError('fourByteCharacter', ['label']));
    };
    LabelUpdaterComponent.prototype.onSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.savingMutex = true;
                        return [4 /*yield*/, this.msisdnService
                                .updateLabel(this.msisdn.id, {
                                label: this.form.get('label').value.trim()
                            })
                                .toPromise()];
                    case 1:
                        _a.sent();
                        this.notificationService.open('SUCCESS_MSG');
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        this.notificationService.open(Array.isArray(e_1.error) ? e_1.error[0] : e_1.error);
                        return [3 /*break*/, 4];
                    case 3:
                        this.savingMutex = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return LabelUpdaterComponent;
}());
export { LabelUpdaterComponent };
